var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityLevel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.85,
    height: 53.85,
    viewBox: "0 0 53.85 53.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5234",
    "data-name": "Group 5234",
    transform: "translate(-877 -521.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21005",
    "data-name": "Path 21005",
    d: "M551.743,226.035V222.69a2.509,2.509,0,0,0-2.509-2.509h-1.673V216H534.181v4.181h-1.673A2.509,2.509,0,0,0,530,222.69v3.345Z",
    transform: "translate(356.363 306.57)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21006",
    "data-name": "Path 21006",
    d: "M540,221v1.673h5.018V221",
    transform: "translate(354.726 305.752)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21007",
    "data-name": "Path 21007",
    d: "M540.071,269.159h-18.4A1.672,1.672,0,0,1,520,267.487V225.673A1.672,1.672,0,0,1,521.673,224h3.345",
    transform: "translate(358 305.261)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21008",
    "data-name": "Path 21008",
    d: "M557,224h5.854a1.672,1.672,0,0,1,1.673,1.673V246.58",
    transform: "translate(351.942 305.261)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5072",
    "data-name": "Rectangle 5072",
    width: 4.938,
    height: 4.938,
    transform: "translate(884.173 550.964)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5073",
    "data-name": "Rectangle 5073",
    width: 4.938,
    height: 4.938,
    transform: "translate(884.173 560.84)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21009",
    "data-name": "Path 21009",
    d: "M528,240.509l2.509,2.509L533.854,238",
    transform: "translate(356.69 302.969)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1342",
    "data-name": "Line 1342",
    x2: 14.814,
    transform: "translate(895.283 543.557)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1343",
    "data-name": "Line 1343",
    x2: 7.407,
    transform: "translate(895.283 553.433)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1344",
    "data-name": "Line 1344",
    x2: 2.469,
    transform: "translate(895.283 563.309)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5074",
    "data-name": "Rectangle 5074",
    d: "M1,0H4.938a0,0,0,0,1,0,0V14.814a0,0,0,0,1,0,0H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0Z",
    transform: "translate(902.69 557.137)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5075",
    "data-name": "Rectangle 5075",
    width: 3.704,
    height: 19.752,
    rx: 1,
    transform: "translate(907.628 554.668)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5076",
    "data-name": "Rectangle 5076",
    d: "M0,0H2.7a1,1,0,0,1,1,1V13.814a1,1,0,0,1-1,1H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(926.146 557.137)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5077",
    "data-name": "Rectangle 5077",
    width: 4.938,
    height: 19.752,
    rx: 1,
    transform: "translate(921.208 554.668)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1345",
    "data-name": "Line 1345",
    x1: 8.642,
    transform: "translate(912.566 567.013)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1346",
    "data-name": "Line 1346",
    x2: 6.173,
    transform: "translate(915.035 563.309)",
    fill: "none",
    stroke: "#31b2cf",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLevel);
export default __webpack_public_path__ + "static/media/activity-level.9163720b4a33f29129416e4a301d6749.svg";
export { ForwardRef as ReactComponent };